import { render, staticRenderFns } from "./Historique.vue?vue&type=template&id=c660aed4&"
import script from "./Historique.vue?vue&type=script&lang=js&"
export * from "./Historique.vue?vue&type=script&lang=js&"
import style0 from "./Historique.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports